<template>
  <div class="login_container">
    <div class="columns">
      <div class="column is-centered">
        <Login></Login>
      </div>
      <div class="column is-centered">
         <infoPanel></infoPanel>
      </div>
    </div>
  </div>
  <!--  -->
</template>

<script>
import Login from "@/components/Login.vue";
import infoPanel from "@/components/infoPanel.vue"

export default {
  name: "login",
  components: {
    Login,
    infoPanel
  }
};
</script>

<style scoped>
.login_container {
  background: #f7f7f7;
  width: 100%;
  height: 100%;
}
</style>

